import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getEmployeeShift } from "../../actions/employeeActions";
import dateToDutchString from "../../utils/date-to-dutch-string";

import { Button } from "@material-ui/core";
import { confirmShift } from "../../actions/companyEmployeeShiftActions";

import FormErrorMessage from "./FormErrorMessage";

const CompanyEmployeeShiftConfirmation = (props) => {
  const [isConfirmedAt, setIsConfirmedAt] = useState(null);
  const [companyEmployeeId, setCompanyEmployeeId] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setIsConfirmedAt(null);
    setCompanyEmployeeId(null);

    const employeeShift = await getEmployeeShift(
      props.employeeEmail,
      props.shiftId,
    );

    setIsConfirmedAt(
      employeeShift.employees[0].CompanyEmployeeShift.isConfirmedAt,
    );
    setCompanyEmployeeId(employeeShift.employees[0].id);
  };

  const handleButtonClick = async () => {
    try {
      setErrorMessage("");
      await confirmShift(companyEmployeeId, props.shiftId);
      await loadData();
    } catch (error) {
      setErrorMessage(error);
    }
  };

  return (
    <Fragment>
      {isConfirmedAt ? (
        <p>
          <b>Bevestigd op {dateToDutchString(isConfirmedAt)}</b>
        </p>
      ) : (
        <Fragment>
          <p>
            <b>Je hebt deze dienst nog niet bevestigd!</b>
          </p>
          <Button
            variant="contained"
            color="primary"
            onClick={handleButtonClick}
          >
            Bevestig deze dienst
          </Button>
        </Fragment>
      )}
      {errorMessage && <FormErrorMessage errorMessage={errorMessage} />}
    </Fragment>
  );
};

CompanyEmployeeShiftConfirmation.propTypes = {
  shiftId: PropTypes.string.isRequired,
  employeeEmail: PropTypes.string.isRequired,
};

export default CompanyEmployeeShiftConfirmation;



// WEBPACK FOOTER //
// ./src/components/forms/CompanyEmployeeShiftConfirmation.js